import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "#000",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		d: "M13 9V2.503A1.5 1.5 0 0 0 11.5 1h-1A1.5 1.5 0 0 0 9 2.503V9H2.503A1.5 1.5 0 0 0 1 10.5v1A1.5 1.5 0 0 0 2.503 13H9v6.497A1.5 1.5 0 0 0 10.5 21h1a1.5 1.5 0 0 0 1.5-1.503V13h6.497A1.5 1.5 0 0 0 21 11.5v-1A1.5 1.5 0 0 0 19.497 9z"
	})
});
export default SvgAddPlus;
